import React from 'react'

function Error() {
  return (
    <div>
      No data available...
    </div>
  )
}

export default Error;


// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Datatable/error/error.jsx